import {useEffect , useState, useRef} from 'react'
import util from "../../utils/utils";
import { useNavigate ,useLocation, useSearchParams} from 'react-router-dom';
import { Mail,ChevronLeft,ChevronsUp,Download, Share2,FileText,FastForward,Crosshair,List} from 'react-feather';
import useGetFullPolicy from './hooks/useGetFullPolicy';
import {LoadingDiv } from '@components/LoadingDiv';
import useGetWordCloud from './hooks/useGetWordCloud';
import useGetPdf from '@hooks/useGetPdf'
import 'echarts-wordcloud';
import ReactEcharts from 'echarts-for-react';
import * as echarts from 'echarts';
import { ReactComponent as SparkSvg } from '@images/icons/spark.svg';
import { ReactComponent as StatisticsSvg } from '@images/icons/statistics.svg';
import MyReactMarkdown from '@components/MyReactMarkdown';
import { FileCard } from './components/FileCard';
import useGetSavedFoldList from '@hooks/useGetSavedFoldList';
import {MarkModal} from '@components/MarkModal'
import {FullScreenMindTreeModal} from '@components/FullScreenMindTreeModal'
import OrgChart from '@twp0217/react-org-chart';
import useCreateSearchFast from '../../hooks/useCreateSearchFast';
import { ScrolltoTopBtn } from '@components/ScrolltoTopBtn';
// Import subject data
import zhongyaojianghuaData from './subjectData/zhongyaojianghua.json';
import xinxingdianlixitongData from './subjectData/xinxingdianlixitong.json';
import shuangtanData from './subjectData/shuangtan.json';
import nengyuanqianyankejiData from './subjectData/nengyuanqianyankeji.json';
import guojimaoyiData from './subjectData/guojimaoyi.json';
import dawanquData from './subjectData/dawanqu.json';
import { POLICY_EMPTY_FILTERED_TAGS } from '@constants';

// We can add more subject data imports here in the future

// Subject data mapping
const subjectDataMap = {
  "重要讲话": zhongyaojianghuaData,
  "新型电力系统": xinxingdianlixitongData,
  "双碳": shuangtanData,
  "能源前沿科技": nengyuanqianyankejiData,
  "国际贸易": guojimaoyiData,
  "大湾区": dawanquData
  // Add more subjects here as they become available
};

export const PolicySubjectPage = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const { pathname } = useLocation();
  const [subjectName, setSubjectName] = useState('');
  const [subjectData, setSubjectData] = useState(null);
  const {getPdfLoading,getPdfData,getPdfAction} = useGetPdf()
  const [mdTxt,setMdTxt] =useState('')
  const [fileName, setFileName] = useState()
  const [fileId, setFileId] = useState()
  const [markData, setMarkData] = useState()
  const [tank,setTank] = useState('')
  const [org,setOrg] = useState('')
  const [tag,setTag] = useState('')

  const { loading,data,setQuery} 
= useCreateSearchFast({manual:true});

  const {savedFoldListLoading, savedFoldListData, savedFoldListRefresh} = useGetSavedFoldList()
  
  useEffect(()=>{
    try{
        const data = searchParams.get('name')
        setSubjectName(data)
        
        // Load subject data based on the subjectName parameter
        if (data && subjectDataMap[data]) {
          setSubjectData(subjectDataMap[data]);
          // Default tag can be set from the data if needed
          if (subjectDataMap[data].mindMapData?.children?.length > 0) {
            const firstTag = subjectDataMap[data].mindMapData.children[0].label;
            setTag(firstTag);

			setQuery({
				search_content:getSearchContent(firstTag),
				search_type:'speed', //ai ,speed
				order_by:"time",
				page_size:50,
				no_record:true,
				do_not_save_search: true, // 添加额外标识，确保不保存搜索记录
				filter_tags:POLICY_EMPTY_FILTERED_TAGS,
				state_grid_related: false
			})
          }
        } else {
          // Fallback to a default subject if the requested one isn't available
          pageBack()
        }
    }catch(e){
        console.log(e)
    }


  },[searchParams])

  const getSearchContent=(label)=> {
	//search_content为所在节点的label，如果有父节点，则加上所在节点的父节点的label，如果有爷爷节点，则加上爷爷节点的label
	if (!subjectData || !subjectData.mindMapData) return label;
    
    const mindMapData = subjectData.mindMapData;
    let searchContent = '';
    
    // Helper function to find a node and its ancestors
    const findNode = (node, targetLabel, ancestors = []) => {
      // Check if current node matches
      if (node.label === targetLabel) {
        return { found: true, ancestors };
      }
      
      // Search in children if they exist
      if (node.children && node.children.length > 0) {
        for (const child of node.children) {
          const result = findNode(child, targetLabel, [...ancestors, node.label]);
          if (result.found) {
            return result;
          }
        }
      }
      
      return { found: false, ancestors: [] };
    };
    
    // Find the node and its ancestors
    const searchResult = findNode(mindMapData, label, []);
    
    // Build the search content in correct hierarchy order: grandparent, parent, node
    if (searchResult.found) {
      const ancestors = searchResult.ancestors;
      
      // Add grandparent (if exists)
      if (ancestors.length >= 2) {
        searchContent += ancestors[ancestors.length - 2];
      }
      
      // Add parent (if exists)
      if (ancestors.length >= 1) {
        // Add a space if we already have content
        if (searchContent) {
          searchContent += ' ';
        }
        searchContent += ancestors[ancestors.length - 1];
      }
      
      // Add the target node label
      if (searchContent) {
        searchContent += ' ';
      }
      searchContent += label;
    } else {
      // If node not found in the tree, just use the label
      searchContent = label;
    }
    
	return searchContent;
  }
  
  // Update search when tag changes
  useEffect(() => {
    if(tag) {
      setQuery({
        search_content:getSearchContent(tag),
        search_type:'speed',
        order_by:"time",
        page_size:50,
        no_record:true,
        do_not_save_search: true, // 添加额外标识，确保不保存搜索记录
        filter_tags:POLICY_EMPTY_FILTERED_TAGS,
        state_grid_related: false
      })
    }
  }, [tag])

  // Update search when tank (province) changes
  useEffect(() => {
    if(tank && tag) {
      setQuery({
        search_content: `${getSearchContent(tag)} ${tank}`,
        search_type:'speed',
        order_by:"time",
        page_size:50,
        no_record:true,
        do_not_save_search: true,
        filter_tags:POLICY_EMPTY_FILTERED_TAGS,
        state_grid_related: false
      })
    } else if(tag) {
      // Reset to original search when no province is selected
      setQuery({
        search_content:getSearchContent(tag),
        search_type:'speed',
        order_by:"time",
        page_size:50,
        no_record:true,
        do_not_save_search: true,
        filter_tags:POLICY_EMPTY_FILTERED_TAGS,
        state_grid_related: false
      })
    }
  }, [tank, tag])

//   const [upBtnVisible,setUpBtnVisible] = useState(false)
  const [index,setIndex] = useState(0)
  const [activeSection,setActiveSection] = useState('')

// useEffect(()=>{
//     window.addEventListener("scroll",e=>{
//         util?.throttle(setUpBtnStatus(),1000)
//     })
// },[])
// const setUpBtnStatus = () => {
//     let scrollTop = document.documentElement.scrollTop
//     // console.log(scrollTop)
//     if(scrollTop > 600){
//         setUpBtnVisible(true)
//     }else{
//         setUpBtnVisible(false)
//     }
// }
const reset = () => {
  setIndex(0);
  document.documentElement.scrollTop = 0
//   document.getElementById('shareTopAnchor').scrollIntoView()
}

const [copied, setCopied] = useState(false)
useEffect(()=>{
    if(copied){
        setTimeout(()=>{
            setCopied(false)
        },2000)
    }
},[copied])
const pageBack = () => {
    const returnUrl = searchParams.get('returnUrl')
    if(returnUrl){
        window.location.href = returnUrl;
    }else{
        window.location.href = `${process.env.REACT_APP_DOMAIN}policy`
    }
}  

const ContentDiv = (_data) => {
        
	return <>
			<>
				{
					_data && _data?.length > 0 ?
					<div className="w-full">
						<div className="lg:mx-4 m-2 flex flex-col-reserve">
							{_data?.map((item,index) => (
								<div key={index}>
									<div className="card bg-base-100 border-b w-full">
										<div className="card-body p-6 pb-4">
											<FileCard
												getPdfAction={getPdfAction}
												fileName={fileName}
												index={index}
												item={item} 
												setFileName={setFileName}
												setFileId={setFileId}
												setMarkData={setMarkData}
												savedFoldListData={savedFoldListData}
												mindmapVisible
												setMdTxt={setMdTxt}
												noClass
												// noSummary
												// noSource
											/>
										</div>                                                
									</div>                                         
								</div>
							))}

						</div>
					</div>
					 :
					<div className="w-full py-8 text-center">
						暂无内容
					</div>
				}
			</>
			{_data?.length > 0 && <div className='flex justify-end mt-1'>
				<button className='btn btn-link'
					onClick={()=>window.open(`${process.env.REACT_APP_DOMAIN}policy/search?k=${subjectName}&org=`,'_blank')}
				>
					查看更多 {'>>'} 
				</button>
			</div>}

	</>
}

// Create echarts word cloud option from data
const createWordCloudOption = (wordCloudData) => {
  return {
    series: [
      {
        type: 'wordCloud',
        gridSize: 2,
        sizeRange: [12, 50],
        rotationRange: [-90, 90],
        shape: 'pentagon',
        textStyle: {
          normal: {
            color: function() {
              return (
                'rgb(' +
                [
                  Math.round(Math.random() * 255),
                  Math.round(Math.random() * 255),
                  Math.round(Math.random() * 255),
                ].join(',') +
                ')'
              );
            },
          },
          emphasis: {
            shadowBlur: 10,
            shadowColor: '#333',
          },
        },
        data: wordCloudData || [],
        tooltip: {
          show: true,
          formatter: function (params) {
            return `${params.name} : ${params.value}`;
          },
        },
      },
    ],
  };
}

// Add refs for scrolling
const contentRef = useRef(null);
const policyRef = useRef(null);
const interpretationRef = useRef(null);
const implementationRef = useRef(null);
const latestRef = useRef(null);

// Scroll handler
const scrollToSection = (ref) => {
  ref.current?.scrollIntoView({ behavior: 'smooth' });
};

// Custom scroll to implementation section
const scrollToImplementationSection = () => {
  if (implementationRef.current) {
    const elementPosition = implementationRef.current.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - 100; // Add some offset

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }
};

// Handle mind map node click
const handleNodeClick = (node) => {
  if (node?.label) {
    console.log('Node clicked:', node.label);
    setTag(node.label);
  }
};

// Update mind map data with active classes
const updateMindMapWithActiveTag = (mindMapData, activeTag) => {
  if (!mindMapData) return null;
  
  // Deep clone to avoid mutating original data
  const clonedData = JSON.parse(JSON.stringify(mindMapData));
  
  // Helper function to split text into groups of 4 characters
  const splitTextIntoGroups = (text, groupSize = 4) => {
    if (!text) return text;
    const chars = text.split('');
    const groups = [];
    for (let i = 0; i < chars.length; i += groupSize) {
      groups.push(chars.slice(i, i + groupSize).join(''));
    }
    return groups.join('\n');
  };
  
  // Helper function to recursively update class names and text
  const updateNodes = (node, depth = 0) => {
    // Check if this node is active - handle text comparison more robustly
    const normalizedNodeLabel = typeof node.label === 'string' ? node.label.replace(/\n/g, '').trim() : '';
    const normalizedActiveTag = typeof activeTag === 'string' ? activeTag.replace(/\n/g, '').trim() : '';

    if (normalizedNodeLabel === normalizedActiveTag) {
      node.className = 'myNodeActiveClass';
    } else {
      // Always set the correct className based on depth, regardless of existing className
      node.className = `myNodeClass${depth}`;
    }

    // For 重要讲话专题的第三层节点 (depth 2)，将文字按四个字一行分割
    // Apply text splitting AFTER checking for active state
    if (subjectName === '重要讲话' && depth === 2 && node.label && node.className !== 'myNodeActiveClass') {
      node.label = splitTextIntoGroups(node.label, 4);
    }

    // Process children if they exist
    if (node.children && node.children.length > 0) {
      node.children.forEach(child => updateNodes(child, depth + 1));
    }

    return node;
  };
  
  return updateNodes(clonedData, 0);
};
const provinceList = ['江苏','山东','广东','浙江','上海','北京','天津','重庆','四川','陕西','湖北','湖南','安徽','江西','福建','海南','云南','贵州','青海','甘肃','宁夏','新疆','内蒙古','广西','西藏','台湾','香港','澳门']

return (
      <div className="md:px-16 lg:px-18 2xl:px-24 3xl:px-36 bg-base-200 w-full flex flex-col h-full " >
            <FullScreenMindTreeModal
                fileName={fileName}
                txt={mdTxt}
                setFileName={setFileName}
                setMdTxt={setMdTxt}            
            />
            <MarkModal
                markData={markData}
                loading={savedFoldListLoading}
                data={savedFoldListData}
                savedFoldListRefresh={savedFoldListRefresh}
            />

        {/* {upBtnVisible && <div className="fixed bottom-8 right-8 z-20">
            <button className="btn btn-circle btn-outline bg-base-100" 
                onClick={()=>window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                })}
            >
                <ChevronsUp size="16"/>
            </button>
        </div>} */}
		<div className='fixed bottom-8 right-8 z-20'>
			<ScrolltoTopBtn/>
		</div>
        <div className='m-3 px-6 max-w-[2360px] w-full mx-auto flex items-center'>
            <span className='hover:primary cursor-pointer' onClick={()=>pageBack()}>返回</span>
            <div className="divider divider-horizontal"></div>
			<div className='flex items-center'>
				<div className='text-3xl font-bold'>
					政策专题  ——【{subjectName}】
				</div>				
				{subjectName && subjectData && <div className='text-xl font-bold text-secondary'>
					{subjectData.fullName || ''}
				</div>}
			</div>
        </div>
        <div className='m-3 flex-1 max-w-[2360px] w-full mx-auto flex gap-6'>
			{/* Side Menu */}
			<div className="hidden md:block sticky top-4 h-fit">
			  <ul className="menu bg-base-100 w-36 rounded-box shadow-lg">
				<li className="menu-title">目录导航</li>
				<li>
				  <a 
					className={`p-4 ${activeSection === 'content' ? 'active' : ''}`}
					onClick={() => scrollToSection(contentRef)}
				  >
								<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
								<path strokeLinecap="round" strokeLinejoin="round" d="m21 7.5-2.25-1.313M21 7.5v2.25m0-2.25-2.25 1.313M3 7.5l2.25-1.313M3 7.5l2.25 1.313M3 7.5v2.25m9 3 2.25-1.313M12 12.75l-2.25-1.313M12 12.75V15m0 6.75 2.25-1.313M12 21.75V19.5m0 2.25-2.25-1.313m0-16.875L12 2.25l2.25 1.313M21 14.25v2.25l-2.25 1.313m-13.5 0L3 16.5v-2.25" />
								</svg>
					内容分类
				  </a>
				</li>
				<li>
				  <a 
					className={`p-4 ${activeSection === 'policy' ? 'active' : ''}`}
					onClick={() => scrollToSection(policyRef)}
				  >
					<List size={16} />
					相关政策
				  </a>
				</li>
				<li>
				  <a 
					className={`p-4 ${activeSection === 'interpretation' ? 'active' : ''}`}
					onClick={() => scrollToSection(interpretationRef)}
				  >
					<FileText size={16} />
					权威解读
				  </a>
				</li>
				<li>
				  <a 
					className={`p-4 ${activeSection === 'implementation' ? 'active' : ''}`}
					onClick={() => scrollToSection(implementationRef)}
				  >
					<FastForward size={16} />
					政策落地
				  </a>
				</li>
				<li>
				  <a 
					className={`p-4 ${activeSection === 'latest' ? 'active' : ''}`}
					onClick={() => scrollToSection(latestRef)}
				  >
					<Crosshair size={16} />
					最新动态
				  </a>
				</li>
			  </ul>
			</div>

			{/* Main Content */}
			<div className='flex-1 flex flex-col gap-6 w-4/5'>
				{/* Content Classification */}
				<div ref={contentRef} className="py-8 px-12 relative w-full h-full bg-base-100 shadow-lg">
					<div className='flex w-full items-center gap-4 mb-6'>
						{/* <SparkSvg/> */}

						<div className="card-title text-2xl text-primary">
								<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
								<path strokeLinecap="round" strokeLinejoin="round" d="m21 7.5-2.25-1.313M21 7.5v2.25m0-2.25-2.25 1.313M3 7.5l2.25-1.313M3 7.5l2.25 1.313M3 7.5v2.25m9 3 2.25-1.313M12 12.75l-2.25-1.313M12 12.75V15m0 6.75 2.25-1.313M12 21.75V19.5m0 2.25-2.25-1.313m0-16.875L12 2.25l2.25 1.313M21 14.25v2.25l-2.25 1.313m-13.5 0L3 16.5v-2.25" />
								</svg>
						内容分类
						</div>
						<div className='text-secondary'>
							政策内容聚类分析
						</div>
					</div>
					<div className={`p-8 flex justify-center items-center mySubjectChart ${subjectName === '重要讲话' ? 'zhongyaojianghua-chart' : ''}`} style={{minHeight: '400px'}}>
						{subjectData && subjectData.mindMapData && (
                          <OrgChart 
                            data={updateMindMapWithActiveTag(subjectData.mindMapData, tag)} 
                            expandable 
                            onClick={handleNodeClick}
                          />
                        )}
					</div>
					<div className='2xl:grid 2xl:grid-cols-2'>
						<div className='2xl:border-r-2'>
							<div className='flex w-full items-center gap-4' ref={policyRef}>
								<div className='divider divider-start flex-1 card-title px-8 text-primary' >
									【{tag}】相关政策:
								</div>
							</div>

							{
								loading ? <LoadingDiv/> :
								<div className='p-8'>
								{ContentDiv(data?.filter(item=>subjectName === '重要讲话' ? item?.policy_class === '重要讲话' : (!item?.policy_class?.includes('解读') && (item?.province?.includes('中央') || item?.province?.includes('国'))))?.slice(0,5))}
								</div>
							}
						</div>
						<div>
							<div className='flex w-full items-center gap-4' ref={interpretationRef}>
								<div className='divider divider-start flex-1 card-title px-8 text-primary' >
									【{tag}】权威解读:
								</div>
							</div>
							{
								loading ? <LoadingDiv/> :
								<div className='p-8'>
									{data?.filter(it=>it?.policy_class?.includes('解读'))?.length > 0 && <div className='flex flex-wrap gap-2 px-4 pb-2 items-center justify-start'>
										<span className="whitespace-nowrap">
											权威媒体：
										</span>
										<>
										
										{[...new Set(data?.filter(it=>it?.policy_class?.includes('解读'))?.map(i=>i?.from_organization))]?.map(item=><button className={`${org===item ? 'btn btn-sm btn-active btn-neutral' : 'btn btn-sm'}`}
											onClick={()=>{setOrg(item)}}
											>{item}</button>)}
										
		
										</>
									</div>}
									{ContentDiv(data?.filter(item=>item?.policy_class?.includes('解读'))?.slice(0,5))}
								</div>
							}
						</div>

					</div>
				</div>

				{/* Policy Implementation */}
				<div ref={implementationRef} className="py-8 px-12 relative w-full h-full bg-base-100 shadow-lg">
						<div className='flex w-full items-center gap-4 mb-6'>
							<div className="card-title  text-2xl text-primary">
							<FastForward size='1.4rem'/>
							政策落地
							</div>
							<div className='text-secondary'>
								省市政策落地实施情况
							</div>

						</div>
						{
									loading ? <LoadingDiv/> :
						<>
						<div className='flex flex-wrap gap-2 px-4 pb-2 items-center justify-start'>
							{data?.filter(item=>provinceList.includes(item?.province?.slice(0,2)))?.length > 0 && <span className="whitespace-nowrap">
							落地省市：
							</span>}
							<>
							{[...new Set(data?.filter(item=>provinceList.includes(item?.province?.slice(0,2)))?.map(i=>i?.province))]?.length > 0 && (
								<button className={`btn btn-sm ${!tank ? 'btn-active btn-neutral' : ''}`}
									onClick={()=>{
										setTank('');
										// Scroll to implementation section after state updates
										setTimeout(() => {
											scrollToImplementationSection();
										}, 500);
									}}
								>
									全部
								</button>
							)}
							{[...new Set(data?.filter(item=>provinceList.includes(item?.province?.slice(0,2)))?.map(i=>i?.province))]?.map(provinceName=><button className={`${tank===provinceName ? 'btn btn-sm btn-active btn-neutral' : 'btn btn-sm'}`}
								onClick={()=>{
									setTank(provinceName);
									// Scroll to implementation section after state updates
									setTimeout(() => {
										scrollToImplementationSection();
									}, 500);
								}}
								>{provinceName}</button>)}

							</>
						</div>
						<div className="w-full py-8 text-center">
							{ContentDiv(data?.filter(item=>provinceList.includes(item?.province?.slice(0,2)) && (!tank || item?.province === tank))?.slice(0,5))}

						</div>
				</>}
				</div>

				{/* Latest Updates */}
				{/* <div ref={latestRef} className="py-8 px-12 relative w-full h-full bg-base-100 shadow-lg">
					<div className='flex w-full items-center gap-4 mb-6'>
						<div className="card-title text-2xl text-primary">
						<Crosshair size='1.4rem'/>
						最新动态
						</div>
						<div className='text-secondary'>
							专题最新政策概览
						</div>
					</div>
					
					<div className='xl:flex xl:gap-6'>
						<div className='px-4 xl:w-7/12'>
							{subjectData && subjectData.newestFiles && ContentDiv(subjectData.newestFiles)}
						</div>
						<div className='xl:w-5/12 px-4'>
													<div className='border my-6 w-full'>
							<h2 className="card-title text-white p-4 px-6 border-b w-full" style={{ backgroundColor: getComputedStyle(document.documentElement).getPropertyValue('--primary-color') || 'var(--primary-color)' }}>
								<SparkSvg color='white' size='1.4rem'/>
								专题智能概述 
								</h2>
								<div className='relative p-8 w-full bg-base-200'>
								<MyReactMarkdown
									source={subjectData?.summaryText || ''}
								/>

								</div>
							</div>
													<div className='border my-6 w-full'>
							<h2 className="card-title text-white p-4 px-6 border-b w-full" style={{ backgroundColor: getComputedStyle(document.documentElement).getPropertyValue('--primary-color') || 'var(--primary-color)' }}>
								<StatisticsSvg color='white' size='1.4rem'/>
								近期热词
							</h2>
							<div className='relative w-full bg-base-200'>
								<ReactEcharts
									option={createWordCloudOption(subjectData?.wordCloudData)}
									notMerge
									lazyUpdate
									className='h-full w-full'
								/>
							</div>
						</div>

						</div>
					</div>
				</div> */}



			</div>
		</div>
	</div>
    )		
}